import { render, staticRenderFns } from "./SysAdmins.vue?vue&type=template&id=433dd5ae"
import script from "./SysAdmins.vue?vue&type=script&lang=js"
export * from "./SysAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports